import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Navbar from '../../components/common/Navbar';
import Footer from '../../components/common/Footer';
import 'line-awesome/dist/line-awesome/css/line-awesome.min.css';
import { Helmet } from 'react-helmet';
import api from '../../services/api';
import { Link } from 'react-router-dom';

const BlogDetail = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [relatedBlogs, setRelatedBlogs] = useState([]);

    const truncateExcerpt = (text, wordCount) => {
    const words = text.split(' ');
    if (words.length > wordCount) {
      return words.slice(0, wordCount).join(' ') + '...';
    }
    return text;
  };
  useEffect(() => {
    const fetchBlogData = async () => {
      try {
        setLoading(true);
        setError(null);
        
        // Fetch the current blog post
        const response = await api.get(`/blog/${slug}`);
        
        if (!response.data.success) {
          throw new Error('Blog post not found');
        }

        setBlog(response.data.data);
        
        // Fetch related blogs
        // if (response.data.data.tags) {
        //   const relatedResponse = await api.get('/blog/related', {
        //     params: {
        //       tags: response.data.data.tags.split(',')[0],
  
        //     }
        //   });
          
        //   if (relatedResponse.data.success) {
        //     setRelatedBlogs(relatedResponse.data.data);
        //   }
        // }
      } catch (err) {
        console.error("Error fetching blog:", err);
        setError(err.message || 'Failed to load blog post');
      } finally {
        setLoading(false);
      }
    };

    fetchBlogData();
  }, [slug]);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  if (loading) {
    return (
      <div className="blog-detail-page">
        <Helmet>
          <title>Loading... - startupbusinesspartners</title>
        </Helmet>
        <Navbar />
        <div className="text-center py-5">Loading blog post...</div>
        <Footer />
      </div>
    );
  }

  if (error) {
    return (
      <div className="blog-detail-page">
        <Helmet>
          <title>Error - startupbusinesspartners</title>
        </Helmet>
        <Navbar />
        <div className="container py-5 text-center">
          <div className="alert alert-danger">{error}</div>
          <button 
            onClick={() => navigate('/blog')} 
            className="btn btn-primary"
          >
            Back to Blog
          </button>
        </div>
        <Footer />
      </div>
    );
  }

  if (!blog) {
    return (
      <div className="blog-detail-page">
        <Helmet>
          <title>Not Found - startupbusinesspartners</title>
        </Helmet>
        <Navbar />
        <div className="container py-5 text-center">
          <div className="alert alert-warning">Blog post not found</div>
          <button 
            onClick={() => navigate('/blog')} 
            className="btn btn-primary"
          >
            Back to Blog
          </button>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div className="blog-detail-page">
      <Helmet>
        <title>{blog.title} - startupbusinesspartners</title>
        <meta name="description" content={blog.excerpt} />
      </Helmet>
      
      <Navbar />
      
      <section className="breadcrumb_area breadcrumb2 bgimage biz_overlay">
     <div className="bg_image_holder" style={{ backgroundImage: `url(https://www.startupbusinesspartners.com/uploads/cms/${blog.image_url || ''})`, opacity: 1 }}>
  <img src={`https://www.startupbusinesspartners.com/uploads/cms/${blog.image_url || ''}`} alt={`https://www.startupbusinesspartners.com/uploads/cms/${blog.image_url || ''}`}/>
</div>

        <div className="container content_above">
          <div className="row">
            <div className="col-md-12">
              <div className="breadcrumb_wrapper d-flex flex-column align-items-center">
                <h4 className="page_title">{blog.title}</h4>
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb m-bottom-30">
                    <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                    <li className="breadcrumb-item"><Link to="/blog">Blog</Link></li>
                    <li className="breadcrumb-item active" aria-current="page">{blog.title}</li>
                  </ol>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section-padding">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8">
              <article className="blog-post">
                {blog.image_url && (
                  <div className="post-thumbnail mb-4">
                    <img 
                      src={`https://www.startupbusinesspartners.com/uploads/cms/${blog.image_url || ''}`} 
                      alt={blog.title} 
                      className="img-fluid rounded"
                    />
                  </div>
                )}
                
                <div className="post-meta mb-4">
                  <span className="post-date me-3">
                    <i className="las la-calendar me-1"></i> {formatDate(blog.created_at)}
                  </span>
                  <span className="post-author me-3">
                    <i className="las la-user me-1"></i> By {blog.author}
                  </span>
                  {blog.tags && (
                    <span className="post-tags">
                      <i className="las la-tags me-1"></i>
                      {blog.tags.split(',').map((tag, index) => (
                        <Link 
                          key={index} 
                          to={`/blog?tag=${tag.trim()}`}
                          className="badge bg-light text-dark me-1"
                        >
                          {tag.trim()}
                        </Link>
                      ))}
                    </span>
                  )}
                </div>
                
                <div 
                  className="post-content" 
                  dangerouslySetInnerHTML={{ __html: blog.content }} 
                />
              </article>

    

              <div className="text-center mt-5">
                <button 
                  onClick={() => navigate('/blog')} 
                  className="btn btn-outline-primary"
                >
                  <i className="las la-arrow-left me-2"></i> Back to Blog
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      <Footer />
    </div>
  );
};

export default BlogDetail;